import { useState } from 'react';

import { usePageContext } from '@xing-com/crate-entity-pages-entity-pages-shared-context-entity-page-context';
import { useFeatureSwitch } from '@xing-com/hub';
import { IconEdit } from '@xing-com/icons';

import { FS_NEW_LINK_SHARE } from '../../../../constants/feature-switches';
import {
  ARTICLES_ARTICLE_EDIT_LINK,
  CONTENT_ARTICLE_EDIT_LINK,
} from '../../../../constants/urls';
import { LinkShareModalPage } from '../../../link-share-modal-page/link-share-modal-page';
import * as Styled from '../article-card-top.styles';

import type { ArticleControlButton } from './types';

type Props = Omit<ArticleControlButton, 'onLoadingChange' | 'onError'>;

export const ArticleEditButton: React.FC<Props> = ({ article, disabled }) => {
  const { pageContext } = usePageContext();

  const articleIdSlugged = article.id;
  const [showModal, setShowModal] = useState(false);
  const isContentArticle = article.typename === 'ContentArticle';

  const showNewLinkShare = useFeatureSwitch(FS_NEW_LINK_SHARE, false);

  const handleOnClick = () => {
    if (showNewLinkShare) {
      if (isContentArticle) {
        setShowModal(true);
      } else {
        const editUrl = ARTICLES_ARTICLE_EDIT_LINK(articleIdSlugged);
        window.location.assign(editUrl);
      }
    } else {
      const cppIdSlugged = pageContext.cppId as string;
      const cppId = cppIdSlugged.split('.')[0];
      const articleId = articleIdSlugged.split('.')[0];
      const editUrl =
        article.typename === 'ContentArticle'
          ? CONTENT_ARTICLE_EDIT_LINK(cppId, articleId)
          : ARTICLES_ARTICLE_EDIT_LINK(articleIdSlugged);

      window.location.assign(editUrl);
    }
  };

  return (
    <>
      <Styled.Button
        data-testid="ARTICLE-EDIT-BUTTON"
        icon={IconEdit}
        size="small"
        variant="tertiary"
        disabled={disabled}
        onClick={handleOnClick}
      />

      {showNewLinkShare && isContentArticle ? (
        <LinkShareModalPage
          showModal={showModal}
          setShowModal={setShowModal}
          linkShareGlobalId={article.globalId}
        />
      ) : null}
    </>
  );
};
